import { VirtualizationSoftwareForm } from "containers/Admin/masters";

const FILTERS = {
    "vsp-360": {
        vsp_360_version: {
            title: 'VSP 360 Version',
            icon: 'server.png'
        },
        vsp_360_services: {
            title: 'VSP 360 Services',
            icon: 'server.png'
        },
         hypervisor: {
            title: 'Hypervisor',
            icon: 'array.png'
        },
        hypervisor: {
            title: 'Hypervisor',
            icon: 'array.png'
        },
        browser: {
            title: 'Browser',
            icon: 'multipath.png'
        },
         storage: {
            title: 'Storage',
            icon: 'array_if.png'
        },
          virtualization_software: {
            title: 'Virtualization Software',
            icon: 'array_if.png'
        },
         host: {
            title: 'Host',
            icon: 'os.png'
        },
        switch: {
            title: 'Switch',
            icon: 'switch.png'
        },
    }
}
export default FILTERS;